/**
 * 图标。**内联 SVG，不引图标库** —— 五个标签加几个功能键，
 * 为它们拖进一个几百 KB 的包不划算，而且图标库的样式常常绕开主题令牌。
 *
 * 一律 `currentColor`：颜色由使用处的 `color` 决定，于是换肤自动生效。
 */
export type IconName =
  | 'lobby' | 'activity' | 'agent' | 'deposit' | 'profile'
  | 'settings' | 'close' | 'chevron' | 'user' | 'sun' | 'moon' | 'palette' | 'globe'
  | 'exit' | 'copy' | 'check' | 'edit' | 'history' | 'mail' | 'receipt';

const PATHS: Record<IconName, string> = {
  // 两张叠着的纸
  copy: 'M9 9h10.5v11H9zM5 15.5V4h10.5',
  check: 'M5 12.5l4.5 4.5L19 7.5',
  // 铅笔
  edit: 'M4.5 19.5h4l10-10-4-4-10 10zM13 7l4 4',
  // 回拨的钟：投注历史
  history: 'M3.5 12a8.5 8.5 0 108.5-8.5 8.4 8.4 0 00-6.2 2.7M3.5 3.5v3.7h3.7M12 7.5V12l3 2',
  // 信封：站内信
  mail: 'M3.5 6.5h17v11h-17zM4 7.2l8 5.8 8-5.8',
  // 小票：购买记录
  receipt: 'M6 3.5h12v17l-2-1.3-2 1.3-2-1.3-2 1.3-2-1.3-2 1.3zM9 8h6M9 11.5h6M9 15h3.5',
  lobby: 'M4 5h6v6H4zM14 5h6v6h-6zM4 13h6v6H4zM14 13h6v6h-6z',
  activity: 'M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L3.5 9.2l5.9-.9z',
  agent: 'M9 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM2.5 20a6.5 6.5 0 0113 0M17 8.5a2.5 2.5 0 100-5M17.5 20a5.5 5.5 0 00-2-4.3',
  deposit: 'M3 8.5A2.5 2.5 0 015.5 6h13A2.5 2.5 0 0121 8.5v7a2.5 2.5 0 01-2.5 2.5h-13A2.5 2.5 0 013 15.5zM3 10.5h18M16.5 14.5h1.5',
  profile: 'M12 12a4 4 0 100-8 4 4 0 000 8zM4 20.5a8 8 0 0116 0',
  settings: 'M12 15.2a3.2 3.2 0 100-6.4 3.2 3.2 0 000 6.4zM19.4 13a7.6 7.6 0 000-2l2-1.6-2-3.4-2.4 1a7.6 7.6 0 00-1.7-1L14.9 3h-3.8l-.4 2.6a7.6 7.6 0 00-1.7 1l-2.4-1-2 3.4L6.6 11a7.6 7.6 0 000 2l-2 1.6 2 3.4 2.4-1a7.6 7.6 0 001.7 1l.4 2.6h3.8l.4-2.6a7.6 7.6 0 001.7-1l2.4 1 2-3.4z',
  close: 'M6 6l12 12M18 6L6 18',
  // 出门：门框 + 往外的箭头。游戏壳上的"返回大厅"
  exit: 'M14 4h3.5A2.5 2.5 0 0120 6.5v11a2.5 2.5 0 01-2.5 2.5H14M10 8l-4 4 4 4M6 12h10',
  chevron: 'M9 6l6 6-6 6',
  user: 'M12 12a4 4 0 100-8 4 4 0 000 8zM4 20.5a8 8 0 0116 0',
  sun: 'M12 16a4 4 0 100-8 4 4 0 000 8zM12 2v2M12 20v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M2 12h2M20 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4',
  moon: 'M20 14.5A8.5 8.5 0 019.5 4a8.5 8.5 0 1010.5 10.5z',
  globe: 'M12 21a9 9 0 100-18 9 9 0 000 18zM3.5 9h17M3.5 15h17M12 3a14 14 0 000 18M12 3a14 14 0 010 18',
  palette: 'M12 21a9 9 0 110-18c4.9 0 9 3.4 9 7.5 0 2.5-2 4.5-4.5 4.5H15a2 2 0 00-1.6 3.2c.4.5.1 1.3-.6 1.3zM7.5 10.5h.01M11 7.5h.01M15.5 8.5h.01',
};

export function Icon({ name, className }: { name: IconName; className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth="1.7"
         strokeLinecap="round" strokeLinejoin="round"
         aria-hidden="true" focusable="false">
      <path d={PATHS[name]} />
    </svg>
  );
}
